export const RefundReasonCodeOptions = [
  {
    label: '个人',
    value: 301001,
  },
  {
    label: '天气',
    value: 301002,
  },
  {
    label: '场馆',
    value: 301003,
  },
  {
    label: '其他',
    value: 301004,
  },
]
